import DataSource from "../../DataSource/index";

export default class TypPolozkyCennikaService {
  constructor(server){
    this.server = server;
  }

  get(id){
    return this.server("typPolozkyCennika.get", {id: id});
  }

  listSource(){
    return new DataSource(this.server, "typPolozkyCennika.list", {limit: 100})
  }

  save(id, item){
    return this.server("typPolozkyCennika.update", {id: id, data: item});
  }

  delete(id){
    return this.server("typPolozkyCennika.delete", {id: id});
  }

}


// WEBPACK FOOTER //
// ./src/Cennik/TypPolozkyCennika/TypPolozkyCennikaService.js